import MinimizedSuperChat from 'ai/components/MinimizedSuperChat/MinimizedSuperChat';
import { withMinimizedSuperChatProps } from 'ai/viewModel/minimizedSuperChat/withMinimizedSuperChatProps';

export default withMinimizedSuperChatProps(MinimizedSuperChat);
